import React from "react";
import { PageHero, CTA } from "@/components/PageHero";

const PROJECTS = [
  { title: "Hospital Management Platform", cat: "Healthcare", desc: "End-to-end HIS with OPD, IPD, pharmacy and billing modules.", img: "https://images.unsplash.com/photo-1580281657527-47f249e8f4df?auto=format&fit=crop&w=800&q=70" },
  { title: "Real Estate Portal", cat: "Real Estate", desc: "Multi-tenant listing platform with lead management.", img: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=800&q=70" },
  { title: "AI Support Chatbot", cat: "AI Automation", desc: "GPT-powered chatbot handling 80% of customer queries.", img: "https://images.unsplash.com/photo-1677442136019-21780ecad995?auto=format&fit=crop&w=800&q=70" },
  { title: "School ERP", cat: "Education", desc: "Complete ERP for 15+ schools with attendance and fee management.", img: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?auto=format&fit=crop&w=800&q=70" },
  { title: "D2C E-Commerce Store", cat: "Retail", desc: "Custom Shopify store with 5x conversion improvement.", img: "https://images.unsplash.com/photo-1607082348824-0a96f2a4b9da?auto=format&fit=crop&w=800&q=70" },
  { title: "Logistics Tracking App", cat: "Logistics", desc: "Real-time fleet tracking with driver mobile app.", img: "https://images.unsplash.com/photo-1601758228041-f3b2795255f1?auto=format&fit=crop&w=800&q=70" },
];

import { useSEO } from "@/hooks/useSEO";

export default function Portfolio() {
  useSEO({
    title: "Portfolio — Easyworks Industries Projects",
    description: "See recent projects delivered by Easyworks Industries across healthcare, real estate, AI, education, retail and logistics.",
  });
  return (
    <div data-testid="portfolio-page">
      <PageHero title="Our Portfolio" subtitle="A selection of recent projects we've delivered across industries." />
      <section className="py-20">
        <div className="container mx-auto max-w-7xl px-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {PROJECTS.map((p, i) => (
            <div key={i} className="rounded-xl overflow-hidden border border-slate-200 bg-white hover:border-blue-200 hover:shadow-lg hover:-translate-y-1 transition-all duration-300" data-testid={`project-${i}`}>
              <div className="h-44 overflow-hidden bg-slate-100">
                <img src={p.img} alt={p.title} className="w-full h-full object-cover" />
              </div>
              <div className="p-5">
                <div className="text-[11px] tracking-[0.2em] font-semibold text-[#2563EB] uppercase mb-1.5">{p.cat}</div>
                <div className="font-semibold text-slate-900 mb-1.5" style={{ fontFamily: "Outfit" }}>{p.title}</div>
                <p className="text-[13px] text-slate-500 leading-relaxed">{p.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
      <CTA />
    </div>
  );
}
